import axios from "axios";
import store from "@/store";
// 创建axios实例
const server = axios.create({
  //baseURL:dict.API_URL,
  //获取用户token，如果没有，跳转到登录页面
  headers: {
    // adminId: store.state.user.id,
    // token: store.state.user.token,
  },
  // responseType: "json",
  //withCredentials: true // 跨域
});
// 添加请求拦截器
server.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    console.log("调用接口错误", error);
    return Promise.reject(error);
  }
);
// 添加响应拦截器
server.interceptors.response.use(
  function (response) {
    if (response.status != 200) {
      console.log("与服务器连接失败，错误码", response.status);
      return response;
    }
    // if (response.data.code == 100) {
    //   store.dispatch("loginOut").then(() => {
    //     location.reload();
    //   });
    // }
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    console.log("服务器响应错误", error);
    return Promise.reject(error);
  }
);
export default server;



// WEBPACK FOOTER //
// ./src/utils/request.js